import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { StyledModal,CalendarHeader,Border } from './styles';
import {
  InputContainer,
  StyledInputV2,
  StyledLabel,
} from '../../CreateEvent/style';
import { withRouter } from 'react-router-dom';
import CommonDropdown from '../../common/CommonDropDown/CommonDropdown';
import { generate12Months } from '../../../utils/methods';
import { CommonButtonPopup } from '../../ReportsV2/styles';
import { CommonButtonBorder } from '../../common/commonStyles';
import dayjs from 'dayjs';


const MonthRangeModal = ({
  show,
  icon,
  title,
  onCancel,
  modalWidth = "500px",
  modalHeight,
  //   onClose,
  selectedStartMonth,
  selectedEndMonth,
  onMonthChange,
  onConfirm,
  //   history,
  tierConfig,
  tierConfigDetails
  //   companyInfo
}) =>{

  const[monthDropdownOpen,setMonthDropdownOpen] = useState(false);




  const SelectPointTierLevels = () => {
    window.console.log("hihi");
    
    return (
      <>
        <div>Select Month To Start Your Rewards It will default to 12 month</div>
        <CommonDropdown
          tileContainerStyle={{ width: "100%", padding:"0px 0px 20px 0px", margin: "20px 0 0 0" }}
          dropdownStyle={{ top: "95px" }}
          labelText={"Start Month"}
          isRequired={true}
          dropdownOpen={monthDropdownOpen}
          placeholder={"Select Month"}
          title={
            selectedStartMonth?.month
          }
          id="dropdown-recurring"
          onClick={() => setMonthDropdownOpen(!monthDropdownOpen)}
          data={generate12Months(tierConfig === 'existing' && dayjs(tierConfigDetails.last_year_end_date).add(1, "day").format("YYYY-MM-DD"))}
          active={selectedStartMonth?.firstDate}
          onSelectParameter={["selectedStartMonth", "firstDate", "month"]}
          // valueString={"Points"}
          itemValue={true}
          valueIndex={2}
          labelMargin={"0px"}
          onSelect={onMonthChange}
          dropIcon={true}
        />
        <InputContainer >
          <StyledLabel isFont="16px" color="#184A61" margin={'0px'}>
            {'End Month'} <span>*</span>
          </StyledLabel> 

          <StyledInputV2
            placeholder={`Default selection based on month selected`}
            value={selectedEndMonth?.month}
            // onChange={(e) => handleChange(key, e.target.value)}
            bgColor="white"
            border="1px solid #BDBDBD"
            color="#184A61"
            disabled
          />
        </InputContainer>
      </>
    );
  };
      
    
    
  return(
    <StyledModal show={show} width={modalWidth} height={modalHeight}>
      <div className="modal-content-padding">
        <CalendarHeader>
          <div className="left-content">
            <div className="icon">{icon && icon}</div>
            <div>{title}</div>
          </div>
          {/* <div className="close-icon" onClick={()=>onClose ? onClose() :onCancel()}>
            {AdminCloseIcon()}
          </div> */}
        </CalendarHeader>
        <Border/>
  
      </div>

      <div className='modal-body'>

        {/* {loading ?
          <Grid>
            {Array.from({ length: 3 }).map((_, index) => (
              <SkeletonLoder
                key={index}
                width="285px"
                height="387px"
                style={{ gap: "25px" }}
              />
            ))}
          </Grid> : SelectPointTierLevels()} */}

        {SelectPointTierLevels()}
      </div>


  
      <div className='footer'>
        <CommonButtonBorder height="48px" width="200px" margin="0px 16px 0px 0px" disabled={!selectedStartMonth || !selectedEndMonth} onClick={() => onCancel()}>
          Back
        </CommonButtonBorder>
        <CommonButtonPopup height="48px" width="200px" disabled={!selectedStartMonth || !selectedEndMonth} onClick={() => onConfirm()}>
          Done
        </CommonButtonPopup>
  
      </div>
    </StyledModal>
  )};


MonthRangeModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title:PropTypes.string, 
  onCancel: PropTypes.func.isRequired,
  modalWidth: PropTypes.string,
  modalHeight: PropTypes.string,
  icon: PropTypes.node.isRequired, 
  onClose:PropTypes.func,
  history:PropTypes.object,
  tierConfig:PropTypes.string,
  companyInfo:PropTypes.object,
  selectedStartMonth:PropTypes.object,
  selectedEndMonth:PropTypes.object,
  onMonthChange:PropTypes.func,
  onConfirm:PropTypes.func,
  tierConfigDetails:PropTypes.object
};

export default withRouter((MonthRangeModal));
  
